import { defaultInternalLogger } from "../internalLogger/const.js";
import { defaultUnpatchedConsole } from "../unpatchedConsole/const.js";
//#region src/extensions/baseExtension.ts
var BaseExtension = class {
	constructor() {
		this.unpatchedConsole = defaultUnpatchedConsole;
		this.internalLogger = defaultInternalLogger;
		this.config = {};
		this.metas = {};
	}
	logDebug(...args) {
		this.internalLogger.debug(`${this.name}\n`, ...args);
	}
	logInfo(...args) {
		this.internalLogger.info(`${this.name}\n`, ...args);
	}
	logWarn(...args) {
		this.internalLogger.warn(`${this.name}\n`, ...args);
	}
	logError(...args) {
		this.internalLogger.error(`${this.name}\n`, ...args);
	}
};
//#endregion
export { BaseExtension };

//# sourceMappingURL=baseExtension.js.map